import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, DialogWrapper, Flex, RemoveModal } from '@/components'
import { useAppContext } from '@/hooks'
import { DependenciesModal } from '@/pages/User/pages/Home/components/Dependencies/components/DependenciesModal'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { useSelectedBranchNumericId } from '@/pages/User/pages/Home/components/TreePanel/TreePanelContext'
import { useDeleteRelationRelationMutation, useGetNodeRelationsRelationQuery } from '@/rtkApi'
import { RelationDto } from '@/rtkApi/mddApiSliceGeneratedV2'
import { getApiErrorDescription, logErrorAndNotifyWithToast } from '@/utils/errorHandling'

import { DependencyLinkCellProps } from '../types'

export const DependenciesActions = <T extends RelationDto>({
	row,
}: DependencyLinkCellProps<T>) => {
	const { t } = useAppContext()
	const branchId = useSelectedBranchNumericId()

	const {
		state: { node, editMode },
	} = useDetailTabContext()

	const { refetch } = useGetNodeRelationsRelationQuery(
		{
			branchId: branchId as number,
			structureId: node.id,
		},
		{ skip: branchId == null },
	)
	const [deleteRelation] = useDeleteRelationRelationMutation()

	const dependency = row.original
	const removeRelation = async () => {
		if (branchId == null || dependency.id == null) return
		try {
			await deleteRelation({
				branchId,
				relationId: dependency.id,
				structureId: node.id,
			}).unwrap()
		} catch (error) {
			logErrorAndNotifyWithToast({
				context: { operation: 'DependenciesActions.remove' },
				detail: getApiErrorDescription(error),
				error,
				messageKey: 'DELETE_RELATION_FAILED',
				t,
			})
			throw error
		}
	}

	return (
		<Flex>
			{dependency.relationType === 'CUSTOM_LINK' &&
				dependency.leftSideStructure?.id === node.id && (
					<>
						<DialogWrapper
							dialog={(opened, onClose) =>
								opened && (
									<DependenciesModal
										node={node}
										dependency={dependency}
										onSave={refetch}
										onClose={onClose}
									/>
								)
							}
						>
							{(onClick) => (
								<Button
									size="sm"
									schema="transparent"
									onClick={onClick}
									disabled={!editMode}
								>
									<FontAwesomeIcon title={t('EDIT')} icon={faEdit} />
								</Button>
							)}
						</DialogWrapper>

						<DialogWrapper
							dialog={(opened, onClose) =>
								opened && (
									<RemoveModal
										onDelete={removeRelation}
										onRemove={refetch}
										removeId={dependency.id}
										textOnModal={t('REMOVE_DESC', [dependency?.name ?? ''])}
										header={t('REMOVE_STEREOTYPE')}
										onClose={onClose}
									/>
								)
							}
						>
							{(onClick) => (
								<Button
									size="sm"
									schema="transparent"
									onClick={onClick}
									disabled={!editMode}
								>
									<FontAwesomeIcon
										title={t('REMOVE')}
										color="#d00"
										icon={faTimes}
									/>
								</Button>
							)}
						</DialogWrapper>
					</>
				)}
		</Flex>
	)
}
